import React, { useEffect, useState } from 'react';
import axios from 'axios';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import FlightSearchForm from './FlightSearchForm';
import airports from '../data/airports.json';
import airlines from '../data/airlines.json';
import { motion, AnimatePresence } from 'framer-motion';
import { Loader2, AlertTriangle, Globe, ArrowRight, BadgeCheck, Globe2, Info, MessageCircle, X } from 'lucide-react';
import PopularDestinations from '../data/composents/PopularDestinations';
import Temoignages from '../data/composents/Temoignages';
import AutresDestinations from '../data/composents/AutresDestinations';
import Footer from '../data/composents/Footer';
import PassengerForm from './PassengerForm';
import ReservationSheet from './ReservationSheet';
import MapAeroports from '../components/MapAeroports';
import NewsList from '../components/NewsList';
import CountryInfo from '../components/CountryInfo';
import AITravelAssistant from '../ia/AITravelAssistant';
import AIFlightAssistant from '../ia/AIFlightAssistant';

function Home() {
  const [flights, setFlights] = useState([]);
  const [loading, setLoading] = useState(false);
  const [erreur, setErreur] = useState(null);
  const [selectedFlight, setSelectedFlight] = useState(null);
  const [reservationData, setReservationData] = useState(null);

  const [travelInfo, setTravelInfo] = useState(null);
  const [news, setNews] = useState([]);
  const [showPassengerForm, setShowPassengerForm] = useState(false);


  const [showChat, setShowChat] = useState(false);



  const [sending, setSending] = useState(false);
  const [sendSuccess, setSendSuccess] = useState(null);



  useEffect(() => {
    if (reservationData && reservationData.email) {
      sendReservationByEmail(reservationData, reservationData.email);
    }
  }, [reservationData]);


  // --- Charger infos pays + news quand un vol est sélectionné ---
  useEffect(() => {
    if (selectedFlight) {
      // On récupère le dernier itinéraire (celui de l’arrivée finale)
      const lastItinerary = selectedFlight.itineraries[selectedFlight.itineraries.length - 1];
      const arrival = lastItinerary.segments[lastItinerary.segments.length - 1];

      // On récupère les infos de l’aéroport d’arrivée
      const airport = getAirportData(arrival.arrival.iataCode);

      // Si on a le code pays ISO -> on appelle les APIs
      if (airport?.iso_country) {
        getTravelInfo(airport.iso_country);      // Infos administratives
        getCountryNews(airport.country);     // Actualités
      }
    }
  }, [selectedFlight]);






  const aircraftTypes = {
    "318": "Airbus A318", "319": "Airbus A319", "320": "Airbus A320", "321": "Airbus A321", "32N": "Airbus A320neo", "32Q": "Airbus A321neo",
    "330": "Airbus A330", "332": "Airbus A330-200", "333": "Airbus A330-300", "338": "Airbus A330-800neo", "339": "Airbus A330-900neo",
    "342": "Airbus A340-200", "343": "Airbus A340-300", "345": "Airbus A340-500", "346": "Airbus A340-600", "350": "Airbus A350",
    "351": "Airbus A350-900", "359": "Airbus A350-900", "35K": "Airbus A350-1000", "388": "Airbus A380-800",
    "717": "Boeing 717", "727": "Boeing 727", "732": "Boeing 737-200", "733": "Boeing 737-300", "734": "Boeing 737-400",
    "735": "Boeing 737-500", "736": "Boeing 737-600", "737": "Boeing 737-700", "738": "Boeing 737-800", "739": "Boeing 737-900",
    "73H": "Boeing 737-800 (winglets)", "73J": "Boeing 737 MAX 9", "73M": "Boeing 737 MAX 8", "752": "Boeing 757-200",
    "753": "Boeing 757-300", "762": "Boeing 767-200", "763": "Boeing 767-300", "764": "Boeing 767-400ER", "772": "Boeing 777-200",
    "773": "Boeing 777-300", "77L": "Boeing 777-200LR", "77W": "Boeing 777-300ER", "778": "Boeing 777-8", "779": "Boeing 777-9",
    "787": "Boeing 787 Dreamliner", "788": "Boeing 787-8 Dreamliner", "789": "Boeing 787-9 Dreamliner", "78X": "Boeing 787-10 Dreamliner",
    "E70": "Embraer 170", "E75": "Embraer 175", "E90": "Embraer 190", "E95": "Embraer 195", "E2S": "Embraer E190-E2", "E2L": "Embraer E195-E2",
    "CRJ": "Bombardier CRJ", "CR1": "Bombardier CRJ100", "CR2": "Bombardier CRJ200", "CR7": "Bombardier CRJ700", "CR9": "Bombardier CRJ900",
    "CRA": "Bombardier CRJ1000", "MRJ": "Mitsubishi SpaceJet", "AT4": "ATR 42", "AT5": "ATR 42-500", "AT7": "ATR 72", "ATR": "ATR 72-600",
    "F70": "Fokker 70", "F100": "Fokker 100", "DC3": "Douglas DC-3", "DC9": "Douglas DC-9", "MD8": "McDonnell Douglas MD-80",
    "MD9": "McDonnell Douglas MD-90", "MD1": "McDonnell Douglas MD-11",
  };

  const getIcaoFromIata = (iata) => {
    if (!airlines?.data) return null;
    const found = airlines.data.find(a => a.iata_code === iata);
    return found?.icao_code || null;
  };

  const getCompagnyName = (iata) => {
    if (!airlines?.data) return null;
    const found = airlines.data.find(a => a.iata_code === iata);
    return found?.name || null;
  };




  // Infos administratives via une API ou backend
  const getTravelInfo = async (countryCode) => {
    try {
      console.log("Fetching travel info for country:", countryCode);
      const res = await axios.get("https://restcountries.com/v3.1/alpha/" + countryCode);
      if (res.data && res.data[0]) {
        setTravelInfo(res.data[0]); // exemple : infos pays
      }
    } catch (e) {
      console.error("Erreur travel info:", e);
    }
  };





  const getCountryNews = async (countryCode) => {
    try {
      const res = await axios.get("https://gnews.io/api/v4/search", {
        params: {
          token: "0c089654d9c7ddea0dcdf186732b9d64",
          lang: "fr",
          q: `"${countryCode}"`,
          max: 10,
          sortby: "publishedAt",
        },
      });
      setNews(res.data.articles || []);
    } catch (e) {
      console.error("Erreur news:", e);
    }
  };




  // --- Fonction météo ---
  const getWeatherForecast = async (lat, lon, datetime) => {
    try {
      const date = new Date(datetime);
      const isoDate = date.toISOString().split("T")[0];
      const hour = date.getHours();

      const res = await axios.get("https://api.open-meteo.com/v1/forecast", {
        params: {
          latitude: lat,
          longitude: lon,
          hourly: "temperature_2m,weathercode",
          start_date: isoDate,
          end_date: isoDate,
          timezone: "auto",
        },
      });

      if (res.data?.hourly) {
        const index = res.data.hourly.time.findIndex((t) => t.includes(`T${String(hour).padStart(2, "0")}:00`));
        if (index !== -1) {
          return {
            temperature: res.data.hourly.temperature_2m[index],
            code: res.data.hourly.weathercode[index],
          };
        }
      }
    } catch (e) {
      console.error("Erreur météo :", e);
    }
    return null;
  };

  // --- Mapping simple Open-Meteo weather codes ---
  const weatherIcons = {
    0: "☀️ ciel clair",
    1: "🌤️ peu nuageux",
    2: "⛅ partiellement nuageux",
    3: "☁️ couvert",
    45: "🌫️ brouillard",
    51: "🌦️ bruine",
    61: "🌧️ pluie",
    71: "❄️ neige",
    95: "⛈️ orage",
  };








  function getItineraryType(flight) {
    try {
      const firstItinerary = flight.itineraries[0];
      const firstSegment = firstItinerary.segments[0];
      const lastSegment = firstItinerary.segments[firstItinerary.segments.length - 1];

      const depAirport = getAirportData(firstSegment.departure.iataCode);
      const arrAirport = getAirportData(lastSegment.arrival.iataCode);

      const depCountry = depAirport?.iso_country || null;
      const arrCountry = arrAirport?.iso_country || null;

      if (!depCountry || !arrCountry) return "inconnu";

      // ✅ National UNIQUEMENT si départ et arrivée en CI
      if (depCountry === "CI" && arrCountry === "CI") {
        return "national";
      }

      // Sinon → International
      return "international";
    } catch (e) {
      console.error("Erreur getItineraryType:", e);
      return "inconnu";
    }
  }












  const getAdjustedPrice = (flight) => {
    try {
      const firstItinerary = flight.itineraries[0];
      const firstSegment = firstItinerary.segments[0];
      const lastSegment = firstItinerary.segments[firstItinerary.segments.length - 1];

      const depAirport = getAirportData(firstSegment.departure.iataCode);
      const arrAirport = getAirportData(lastSegment.arrival.iataCode);

      // base price depuis la structure Amadeus : assure-toi que flight.price.total est présent
      let basePrice = parseFloat(flight.price?.total ?? flight.price ?? 0);
      if (isNaN(basePrice)) basePrice = 0;

      // Si on a bien les pays
      const depCountry = depAirport?.iso_country ?? null;
      const arrCountry = arrAirport?.iso_country ?? null;

      // Si pays absents, on laisse basePrice (mais on loggue pour debug)
      if (!depCountry || !arrCountry) {
        console.warn("Missing iso_country for airport(s):", {
          dep: firstSegment.departure.iataCode, depCountry,
          arr: lastSegment.arrival.iataCode, arrCountry
        });
        // retourne basePrice (nombre) pour éviter string
        return Math.round(basePrice);
      }

      if (depCountry === "CI" && arrCountry === "CI") {
        basePrice += 20000; // National
      } else {
        basePrice += 50000; // International
      }

      return Math.round(basePrice); // Number entier (ex: 80100)
    } catch (e) {
      console.error("getAdjustedPrice error:", e);
      return Math.round(parseFloat(flight.price?.total ?? 0) || 0);
    }
  };



  const handleSearch = async (searchParams) => {
    setLoading(true);
    setErreur(null);
    setFlights([]);

    try {
      const res = await axios.get(
        'https://djatervoyage.com/backend_djatervoyage/backend_amadeus/searchFlights.php',
        {
          params: {
            ...searchParams,
            max: 10,
          },
        }
      );

      if (res.data.data?.length) {
        setFlights(res.data.data);
      } else {
        setErreur('Aucune offre trouvée.');
      }
    } catch (error) {
      console.error(error);
      setErreur("Erreur lors de la récupération des vols.");
    } finally {
      setLoading(false);
    }
  };

  const formatTime = (datetime) =>
    new Date(datetime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

  const formatDate = (datetime) =>
    new Date(datetime).toLocaleDateString();

  const getAirportData = (iata) =>
    airports.find((a) => a.iata_code === iata);

  const renderFlag = (iata) => {
    const airport = getAirportData(iata);
    if (!airport?.iso_country) return null;
    const countryCode = airport.iso_country.toLowerCase();
    return (
      <img
        src={`https://flagcdn.com/w40/${countryCode}.png`}
        alt={`Drapeau ${airport.country}`}
        title={airport.country}
        className="inline-block ml-2 w-5 h-auto rounded shadow"
      />
    );
  };

  const renderAirlineLogos = (carrierCodes) =>
    carrierCodes.map((iata, idx) => {
      const icao = getIcaoFromIata(iata);
      const logoPath = icao ? `./images/${icao}.png` : '/data/images/default.png';
      return (
        <img
          key={iata + '-' + idx}
          src={logoPath}
          alt={iata}
          title={iata}
          className="inline-block w-auto h-auto mr-2  border shadow"
          onError={(e) => { e.target.style.display = 'none'; }}
        />
      );
    });



  const AirportInfo = ({ iata, datetime }) => {
    const airport = getAirportData(iata);
    const [weather, setWeather] = useState(null);

    useEffect(() => {
      if (airport?.latitude && airport?.longitude && datetime) {
        getWeatherForecast(airport.latitude, airport.longitude, datetime).then(setWeather);
      }
    }, [iata, datetime, airport?.latitude, airport?.longitude]);

    if (!airport) return <span>{iata}</span>;

    return (
      <div className="text-base text-gray-700 leading-snug mt-2 p-4 rounded-2xl shadow-md bg-white border border-gray-200">
        <div className="text-lg font-bold mb-1 flex items-center gap-2">
          {airport.name} <span className="text-sm text-gray-500">({airport.iata_code})</span> {renderFlag(iata)}
        </div>
        <div className="text-sm mb-1">{airport.city}, {airport.region}, {airport.country}</div>

        <div className="flex gap-4 text-sm text-gray-600 mb-2">
          <span>Fuseau : <span className="font-medium">{airport.timezone}</span></span>
          <span>Décalage : <span className="font-medium">{airport.time_offset}</span></span>
        </div>

        <div className="text-sm text-gray-500 mb-2">
          Lat: {airport.latitude} | Long: {airport.longitude}
        </div>

        {/* Bloc météo mis en avant */}
        {weather && (
          <div className="mt-2 flex items-center gap-3 bg-blue-100 rounded-xl px-3 py-2 shadow-inner">
            <span className="text-2xl">{weatherIcons[weather.code] || "🌍"}</span>
            <span className="text-lg font-semibold">{weather.temperature}°C prévu</span>
          </div>
        )}

        <div className="mt-3 rounded-xl overflow-hidden border border-gray-300" style={{ position: "relative", zIndex: 0 }}>
          <MapAeroports aeroports={airport} />
        </div>
      </div>
    );
  };



  const renderItinerary = (itinerary, type) => {
    const segments = itinerary.segments;
    const departure = segments[0];
    const arrival = segments[segments.length - 1];
    const stops = segments.length - 1;
    const airlineCodes = [...new Set(segments.map((s) => s.carrierCode))];

    return (
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className={`rounded-2xl p-6 mb-6 border-2 shadow-lg ${type === 'retour' ? 'bg-gradient-to-r from-yellow-50 to-white border-yellow-300' : 'bg-gradient-to-r from-blue-50 to-white border-blue-300'}`}
      >
        <div className="flex items-center gap-3 mb-2">
          {type === 'retour' ? <Globe className="text-yellow-400" /> : <Globe className="text-blue-400" />}
          <h3 className="text-xl font-bold text-gray-800">{type === 'retour' ? 'Vol retour' : 'Vol aller'}</h3>
          <BadgeCheck className="text-green-400" />
        </div>
        <div className="flex items-center text-lg font-semibold text-blue-800 mb-2">
          <span className="uppercase">{departure.departure.iataCode}</span> {renderFlag(departure.departure.iataCode)}
          <ArrowRight className="mx-2 text-blue-400" />
          <span className="uppercase">{arrival.arrival.iataCode}</span> {renderFlag(arrival.arrival.iataCode)}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
          <div className="bg-blue-50 rounded-lg p-3 shadow-sm">
            <strong className="text-blue-700">Départ :</strong> {formatTime(departure.departure.at)}
            <AirportInfo iata={departure.departure.iataCode} datetime={departure.departure.at} />
          </div>
          <div className="bg-yellow-50 rounded-lg p-3 shadow-sm">
            <strong className="text-yellow-700">Arrivée :</strong> {formatTime(arrival.arrival.at)}
            <AirportInfo iata={arrival.arrival.iataCode} datetime={arrival.arrival.at} />
          </div>
        </div>
        <div className="mt-4 flex flex-wrap gap-4 items-center text-sm">
          <span className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full font-semibold shadow">Date : {formatDate(departure.departure.at)}</span>
          <span className="bg-yellow-100 text-yellow-700 px-3 py-1 rounded-full font-semibold shadow">Durée : {itinerary.duration.replace("PT", "").toLowerCase()}</span>
          <span className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full font-semibold shadow">Escale{stops > 1 ? 's' : ''} : {stops}</span>
        </div>
        <div className="flex items-center gap-4 mt-4">
          <span className="text-blue-700 font-bold">Compagnies :</span>
          <span className="font-bold text-blue-900 text-lg">
            {airlineCodes.map(code => getCompagnyName(code)).filter(Boolean).join(', ')}
          </span>
          <div className=" items-center">{renderAirlineLogos(airlineCodes)}</div>
        </div>
        <details className="group mt-6 border-t pt-3 cursor-pointer">
          <summary className="text-blue-700 font-medium">📋 Détails du trajet</summary>
          <div className="mt-2 space-y-3 text-sm">
            {segments.map((seg, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, x: -10 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.3, delay: idx * 0.1 }}
                className="border-t pt-2"
              >
                <div><strong>Équipement :</strong> {aircraftTypes[seg.aircraft?.code] || seg.aircraft?.code || "N/A"}</div>
                <div><strong>Vol :</strong> {seg.carrierCode} {seg.number}</div>
                <div><strong>De :</strong> {seg.departure.iataCode} à {formatTime(seg.departure.at)}</div>
                <div><strong>À :</strong> {seg.arrival.iataCode} à {formatTime(seg.arrival.at)}</div>
                <div><strong>Durée :</strong> {seg.duration.replace("PT", "").toLowerCase()}</div>
              </motion.div>
            ))}
          </div>
        </details>
      </motion.div>
    );
  };


  const sendReservationByEmail = async (reservationData, email) => {
    try {
      setSending(true);
      setSendSuccess(null);

      // Capture la fiche réservation
      const input = document.getElementById("reservation-sheet");
      const canvas = await html2canvas(input, { scale: 1 }); // scale 1 pour limiter la taille
      const imgData = canvas.toDataURL("image/png");

      // Génère le PDF
      const pdf = new jsPDF("p", "mm", "a4");
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

      // Export en blob (plus sûr que File)
      const pdfBlob = pdf.output("blob");

      // Prépare le fichier et formData
      const formData = new FormData();
      formData.append("file", new Blob([pdfBlob], { type: "application/pdf" }), "reservation.pdf");
      formData.append("email", email);

      // Envoi au backend (laisser Axios gérer Content-Type)
      await axios.post(
        "https://djatervoyage.com/backend_djatervoyage/email/send_reservation.php",
        formData
      );

      setSendSuccess(true);
    } catch (error) {
      console.error("❌ Erreur d'envoi :", error.response?.data || error.message);
      setSendSuccess(false);
    } finally {
      setSending(false);
    }
  };





  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-yellow-50">
      {/* Header / Hero */}
      <header className="relative w-full h-screen overflow-hidden">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
        >
          <source
            src="./videos/video1.mp4"
            type="video/mp4"
          />
        </video>
        <div className="absolute inset-0 bg-black/10" />
        <motion.div
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="relative z-10 flex flex-col justify-center items-center text-center h-full px-6"
        >
          <motion.h1
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="text-6xl md:text-8xl font-extrabold text-white drop-shadow-2xl tracking-wide"
          >
            Djater Voyage
          </motion.h1>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.5 }}
            className="mt-6 text-lg md:text-2xl text-gray-200 max-w-2xl leading-relaxed"
          >
            ✈️ Partez à la découverte du monde avec{" "}
            <span className="text-yellow-400 font-semibold">style et sérénité</span>.
            <br /> Réservez et vivez vos plus belles aventures.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.8 }}
            className="mt-10 flex flex-wrap gap-6 justify-center"
          >
            {/*
            <a
              href="https://djatervoyage.com/assistant"
              className="flex items-center gap-2 bg-yellow-400 hover:bg-yellow-500 text-blue-900 font-bold py-3 px-8 rounded-full shadow-xl transition transform hover:scale-105"
            >
              <PlaneTakeoff className="w-5 h-5" />
              Trouver un vol avec notre assistant
            </a>
            */}
            <a
              href="apropos"
              className="flex items-center gap-2 bg-blue-500 hover:bg-blue-100 text-white font-bold py-3 px-8 rounded-full shadow-xl transition transform hover:scale-105"
            >
              <Info className="w-5 h-5" />
              A propos
            </a>
            <a
              href="#contact"
              className="flex items-center gap-2 bg-white hover:bg-blue-100 text-blue-700 font-bold py-3 px-8 rounded-full shadow-xl transition transform hover:scale-105"
            >
              <Globe2 className="w-5 h-5" />
              Contactez-nous
            </a>
          </motion.div>
        </motion.div>
      </header>



      {/* Feedback envoi email */}
      <AnimatePresence>
        {sending && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 flex items-center justify-center bg-black/40 z-50"
          >
            <div className="bg-white rounded-2xl shadow-xl p-8 flex flex-col items-center">
              <Loader2 className="animate-spin text-blue-600 w-10 h-10 mb-4" />
              <p className="text-blue-700 font-semibold">
                Envoi de la confirmation de réservation en cours...
              </p>
            </div>
          </motion.div>
        )}

        {sendSuccess === true && (
          <motion.div
            initial={{ y: -20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed top-6 right-6 bg-green-100 border border-green-400 text-green-800 px-6 py-3 rounded-xl shadow-lg z-50"
          >
            ✅ La fiche de réservation a été envoyée avec succès !
          </motion.div>
        )}

        {sendSuccess === false && (
          <motion.div
            initial={{ y: -20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed top-6 right-6 bg-red-100 border border-red-400 text-red-800 px-6 py-3 rounded-xl shadow-lg z-50"
          >
            ⚠️ Impossible d’envoyer le PDF par email.
          </motion.div>
        )}
      </AnimatePresence>

      {selectedFlight && !reservationData && (
        <>
          {/* Overlay infos pays + news */}
          {(travelInfo || news.length > 0) && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm animate-fadeIn">
              <div className="relative bg-white max-w-4xl w-full max-h-[90vh] overflow-y-auto rounded-2xl shadow-2xl p-8 animate-slideUp">

                {/* Header avec actions */}
                <div className="flex justify-between items-center border-b pb-3 mb-4">
                  <h2 className="text-xl font-semibold text-gray-800">
                    Informations voyage
                  </h2>

                  <div className="flex gap-3">
                    {/* Bouton continuer */}
                    <button
                      onClick={() => {
                        setNews([]);
                        setTravelInfo(null);
                        setShowPassengerForm(true); // aller à la réservation
                      }}
                      className="flex items-center gap-2 px-4 py-2 bg-green-600 hover:bg-green-700 
                       text-white font-medium rounded-full shadow transition"
                    >
                      <span>Continuer la reservation</span>
                      <svg xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </button>

                    {/* Bouton fermer */}
                    <button
                      onClick={() => {
                        setNews([]);
                        setTravelInfo(null);
                      }}
                      className="flex items-center justify-center w-10 h-10 rounded-full 
                       bg-gray-200 hover:bg-red-500 hover:text-white 
                       text-gray-600 transition"
                      aria-label="Fermer"
                    >
                      ✕
                    </button>
                  </div>
                </div>

                {/* Contenu : infos pays + news */}
                <div className="space-y-6">
                  {travelInfo && (
                    <div className="p-4 bg-gray-50 rounded-xl shadow-sm">
                      <CountryInfo country={travelInfo} />
                    </div>
                  )}
                  {news.length > 0 && (
                    <div className="p-4 bg-gray-50 rounded-xl shadow-sm">
                      <NewsList news={news} />
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}




          {/* Overlay modal PassengerForm */}
          <AnimatePresence>
            {showPassengerForm && (
              <PassengerForm
                flight={selectedFlight}
                onClose={() => setShowPassengerForm(false)}
                onReservation={(amadeusData) => setReservationData(amadeusData)}
              />
            )}
          </AnimatePresence>
        </>
      )}



      {reservationData ? (
        <>
          <ReservationSheet reservationData={reservationData} />
        </>
      ) : (
        <>
          {/* Formulaire de recherche */}
          <section id="search" className="container mx-auto px-4 py-8 bg-white rounded-2xl shadow-xl mb-12 border-2 border-blue-100">
            <FlightSearchForm onSearch={handleSearch} />
            <AnimatePresence>
              {loading && (
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  className="text-center mt-10"
                >
                  <Loader2 className="mx-auto animate-spin text-blue-600 w-10 h-10" />
                  <p className="text-blue-600 mt-4 text-lg font-semibold">Recherche de vols en cours...</p>
                </motion.div>
              )}
            </AnimatePresence>
            <AnimatePresence>
              {erreur && (
                <motion.div
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: 10 }}
                  className="text-center mt-8 text-red-600 flex flex-col items-center"
                >
                  <AlertTriangle className="w-8 h-8 mb-2" />
                  <p className="text-lg font-semibold">{erreur}</p>
                </motion.div>
              )}
            </AnimatePresence>
            <AnimatePresence>
              {!loading && flights.length > 0 && (
                <>
                  <motion.h2
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="text-4xl font-bold text-center text-blue-700 mb-8"
                  >
                    ✈️ Résultats de recherche
                  </motion.h2>
                  <div className="mt-10 space-y-8">
                    {flights.map((flight, index) => (
                      <motion.div
                        key={index}
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: index * 0.07 }}
                        className="bg-white shadow-2xl rounded-2xl p-8 border-2 border-blue-100 hover:shadow-3xl transition transform hover:scale-[1.02]"
                      >
                        {flight.itineraries.map((itin, iIdx) =>
                          <div key={iIdx}>
                            {renderItinerary(itin, iIdx === 1 ? 'retour' : 'aller')}
                          </div>
                        )}
                        <div className="mt-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4 border-t pt-4">
                          <div className="flex items-center gap-2">
                            <span className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full font-semibold shadow">Classe :</span>
                            <span className="font-bold">{flight.travelerPricings[0]?.fareDetailsBySegment[0]?.cabin || 'Non spécifiée'}</span>
                          </div>
                          <div className="flex flex-col gap-2 w-full md:w-auto">
                            <button
                              onClick={() => setFlights(prev =>
                                prev.map((f, i) =>
                                  i === index ? { ...f, showBaggage: !f.showBaggage } : f
                                )
                              )}
                              className="flex items-center justify-between bg-yellow-100 text-yellow-700 px-3 py-2 rounded-full font-semibold shadow hover:bg-yellow-200 transition"
                            >
                              Bagages inclus
                              <span>{flight.showBaggage ? "▲" : "▼"}</span>
                            </button>
                            <AnimatePresence>
                              {flight.showBaggage && (
                                <motion.div
                                  initial={{ height: 0, opacity: 0 }}
                                  animate={{ height: "auto", opacity: 1 }}
                                  exit={{ height: 0, opacity: 0 }}
                                  transition={{ duration: 0.3 }}
                                  className="overflow-hidden flex flex-col gap-2 mt-2"
                                >
                                  {flight.travelerPricings[0]?.fareDetailsBySegment.map((fare, idx) => {
                                    const bags = fare.includedCheckedBags;
                                    const brandedFareLabels = {
                                      LIGHTBAG: "Tarif Light : 1 bagage cabine inclus, pas de bagage soute",
                                      STANDARD: "Tarif Standard : 1 bagage cabine + 1 bagage soute",
                                      FLEX: "Tarif Flexible : modifications possibles, + bagages",
                                      BUSINESS: "Classe Business : services premium et plus de bagages",
                                    };
                                    const conditions = fare.conditions
                                      ? [
                                        fare.conditions.cabinRestriction && "Restriction cabine",
                                        fare.conditions.changeable ? "Modifiable" : "Non modifiable",
                                        fare.conditions.refundable ? "Remboursable" : "Non remboursable",
                                      ].filter(Boolean)
                                      : [];
                                    return (
                                      <div
                                        key={idx}
                                        className="text-blue-900 font-bold flex flex-col border border-gray-200 rounded-xl p-3 shadow-sm bg-white"
                                      >
                                        <span className="flex items-center gap-2">
                                          ✈️ Segment {idx + 1} :
                                          {bags?.quantity
                                            ? `${bags.quantity} bagage${bags.quantity > 1 ? "s" : ""}`
                                            : "Aucun"}
                                          {bags?.weight && bags?.weightUnit
                                            ? ` (${bags.weight} ${bags.weightUnit})`
                                            : ""}
                                        </span>
                                        {bags?.weight && (
                                          <span className="text-xs text-gray-600">
                                            Poids max autorisé : {bags.weight} {bags.weightUnit} par bagage
                                          </span>
                                        )}
                                        {fare.fareBasis && (
                                          <span className="text-xs text-gray-600">
                                            Code tarif (basis) : {fare.fareBasis}
                                          </span>
                                        )}
                                        {fare.fareType && (
                                          <span className="text-xs text-gray-600">
                                            Type tarif : {fare.fareType}
                                          </span>
                                        )}
                                        {fare.brandedFare && (
                                          <span className="text-xs text-gray-600">
                                            Branded Fare :{" "}
                                            <span className="font-medium text-indigo-600">
                                              {fare.brandedFare}
                                            </span>{" "}
                                            – {brandedFareLabels[fare.brandedFare] || "Tarif spécial"}
                                          </span>
                                        )}
                                        {conditions.length > 0 && (
                                          <ul className="text-xs text-gray-500 list-disc ml-4 mt-1">
                                            {conditions.map((c, i) => (
                                              <li key={i}>{c}</li>
                                            ))}
                                          </ul>
                                        )}
                                      </div>
                                    );
                                  })}
                                </motion.div>
                              )}
                            </AnimatePresence>





                          </div>
                          <motion.div
                            initial={{ scale: 0.95, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            transition={{ duration: 0.5 }}
                            className="flex flex-col md:flex-row items-center justify-between gap-6 bg-gradient-to-r from-green-50 via-white to-green-100 rounded-2xl p-6 shadow-xl border-2 border-green-200 mt-4"
                          >
                            <div className="flex items-center gap-4">
                              <span className="bg-green-200 text-green-900 px-5 py-2 rounded-full font-extrabold shadow-lg text-lg flex items-center gap-2 animate-pulse">
                                💸 Prix total :
                              </span>
                              <span className="text-green-700 font-extrabold text-4xl drop-shadow-lg tracking-wide">
                                {getAdjustedPrice(flight)} {flight.price.currency}
                              </span>
                            </div>
                            <motion.button
                              whileHover={{ scale: 1.07, backgroundColor: "#22c55e" }}
                              whileTap={{ scale: 0.97 }}
                              className="bg-gradient-to-r from-green-600 to-green-400 hover:from-green-700 hover:to-green-500 text-white font-bold py-4 px-10 rounded-full shadow-2xl transition text-xl flex items-center gap-3"
                              onClick={() => setSelectedFlight({
                                ...flight,
                                adjustedPrice: getAdjustedPrice(flight),
                                itineraryType: getItineraryType(flight)
                              })}

                            >
                              ✈️ Réserver ce vol
                            </motion.button>
                          </motion.div>
                        </div>
                         {/* Mini-agent intégré */}
                <AIFlightAssistant flight={flight} getAdjustedPrice={getAdjustedPrice} />
                      </motion.div>
                    ))}
                  </div>
                </>
              )}
            </AnimatePresence>
          </section>



          <PopularDestinations />
          <AutresDestinations />
          <Temoignages />
          <Footer />


          {/* Bouton flottant pour ouvrir/fermer le chatbot */}
          <button
            onClick={() => setShowChat(!showChat)}
            className="fixed bottom-6 right-6 bg-blue-600 text-white p-4 rounded-full shadow-lg hover:bg-blue-700 transition z-50"
          >
            {showChat ? <X className="w-6 h-6" /> : <MessageCircle className="w-6 h-6" />}
          </button>




          {/* Fenêtre du chatbot */}
          <AnimatePresence>
            {showChat && (
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 50 }}
                transition={{ duration: 0.3 }}
                className="fixed bottom-20 right-6 w-96   rounded-2xl  border z-50 overflow-hidden flex flex-col"
              >
                <AITravelAssistant
                  onFlightSelect={(flight) => {
                    const adjustedPrice = getAdjustedPrice(flight);
                    const itineraryType = getItineraryType(flight);
                    setSelectedFlight({ ...flight, adjustedPrice, itineraryType });
                  }}
                  onOpenSearch={() => {
                    window.scrollTo({ top: document.getElementById('search').offsetTop, behavior: 'smooth' });
                  }}
                  onOpenReservation={() => setShowPassengerForm(true)}
                />

              </motion.div>
            )}
          </AnimatePresence>
        </>
      )}
    </div>

  );
}

export default Home;